"use client";

import { TileViewComponentProps } from "../../../lib/grid-tile/types";
import { Image } from "@crystallize/reactjs-components";
import { LinkRenderer } from "../../../lib/grid-tile/linkRenderer";
import Link from "next/link";
import type { Image as ImageType } from "~/use-cases/contracts/Image";

type ImageVariant = ImageType["variants"][number];

export const ImageButton: React.FC<TileViewComponentProps> = ({ tile }) => {
  const { content, ctas, styling } = tile;
  const { font, button } = styling || {};

  return (
    <div className="w-full imageButton">
      {content.images &&
        content.images.map((image: ImageType) => {
          // Sjekk om linken eksisterer
          const linkExists = ctas && ctas[0] && ctas[0].link;

          // Rendre bilde med eller uten link basert på om linken eksisterer
          return linkExists ? (
            <Link href={ctas[0].link} key={ctas[0].link}>
              <Image
                {...image}
                url={
                  image.variants.reduce((prev: ImageVariant | null, curr) => {
                    if (
                      curr?.url.endsWith(".png") &&
                      (prev === null || curr.width > prev.width)
                    )
                      return curr;
                    return prev;
                  }, null)?.url ?? image.url
                }
                loading="eager"
                sizes="(max-width: 500px) 300px, 700px"
                className="[&>picture>img]:w-full [&>picture>img]:h-full [&>picture>img]:object-cover"
                key={image.url}
              />
            </Link>
          ) : (
            <Image
              {...image}
              url={
                image.variants.reduce((prev: ImageVariant | null, curr) => {
                  if (
                    curr?.url.endsWith(".png") &&
                    (prev === null || curr.width > prev.width)
                  )
                    return curr;
                  return prev;
                }, null)?.url ?? image.url
              }
              loading="eager"
              sizes="(max-width: 500px) 300px, 700px"
              className="[&>picture>img]:w-full [&>picture>img]:h-full [&>picture>img]:object-cover"
              key={image.url}
            />
          );
        })}
    </div>
  );
};
